import { defineMessages } from 'react-intl';

const routinMessages = defineMessages({
    homePageTitle: {
        id: 'routing.routingMessages.homePageTitle',
        description: 'Home Page Title',
        defaultMessage: 'Home'
    },
    categoryPageTitle: {
        id: 'routing.routingMessages.categoryPageTitle',
        description: 'Category Page Title',
        defaultMessage: 'Category'
    },
    pdpPageTitle: {
        id: 'routing.routingMessages.pdpPageTitle',
        description: 'PDP Page Title',
        defaultMessage: 'Create your gift card'
    },
    paymentPageTitle: {
        id: 'routing.routingMessages.paymentPageTitle',
        description: 'Payment Page Title',
        defaultMessage: 'Checkout'
    },
    orderSuccessPageTitle: {
        id: 'routing.routingMessages.orderSuccessPageTitle',
        description: 'Order Success Page Title',
        defaultMessage: 'Order Success'
    },
    orderFailurePageTitle: {
        id: 'routing.routingMessages.orderFailurePageTitle',
        description: 'Order Failure Page Title',
        defaultMessage: 'Order Failure'
    },
    cartPageTitle: {
        id: 'routing.routingMessages.cartPageTitle',
        description: 'Cart Page Title',
        defaultMessage: 'Cart'
    },
    confirmationPageTitle: {
        id: 'routing.routingMessages.confirmationPageTitle',
        description: 'Confirmation Page Title',
        defaultMessage: 'Confirmation'
    },
    orderCancellationPageTitle: {
        id: 'routing.routingMessages.orderCancellationPageTitle',
        description: 'Order Cancellation Page Title',
        defaultMessage: 'Order Cancellation'
    }
});

export default routinMessages;
